import { baseApi } from './baseApi';
import type {
  CustomerListResponse,
  CustomerCreateRequest,
  CustomerUpdateRequest,
  CustomerResponse,
  CustomerCreateResponse,
  CustomerListParams,
} from '../types/customer';

export const customerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomers: builder.query<CustomerListResponse, CustomerListParams>({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();
        
        // Set default values
        searchParams.set('page', String(params.page || 1));
        searchParams.set('limit', String(params.limit || 20));
        
        // Add optional parameters
        if (params.search) searchParams.set('search', params.search);
        if (params.plan) searchParams.set('plan', params.plan);
        if (params.subscriptionStatus) searchParams.set('subscriptionStatus', params.subscriptionStatus);
        
        return `/customers?${searchParams.toString()}`;
      },
      providesTags: ['Customer'],
    }),
    
    getCustomer: builder.query<CustomerResponse, string>({
      query: (id) => `/customers/${id}`,
      providesTags: (result, error, id) => [{ type: 'Customer', id }],
    }),
    
    createCustomer: builder.mutation<CustomerCreateResponse, CustomerCreateRequest>({
      query: (customer) => ({
        url: '/customers',
        method: 'POST',
        body: customer,
      }),
      invalidatesTags: ['Customer'],
    }),
    
    updateCustomer: builder.mutation<CustomerResponse, CustomerUpdateRequest>({
      query: ({ id, ...customer }) => ({
        url: `/customers/${id}`,
        method: 'PUT',
        body: customer,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Customer', id }, 'Customer'],
    }),
    
    deleteCustomer: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `/customers/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Customer'],
    }),
  }),
});

export const {
  useGetCustomersQuery,
  useGetCustomerQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,
} = customerApi;